import initialState from '../../data/notes';
import ActionTypes from '../constants/action-types';

const NotesReducers = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_PERSONAL_NOTES_IS_BUSY:
            return {
                ...state,
                isBusy: action.payload,
            };

        case ActionTypes.SET_PERSONAL_NOTES_IS_OPEN:
            return {
                ...state,
                isOpen: action.payload,
            };

        case ActionTypes.SET_ACTIVE_PERSONAL_NOTE:
            return {
                ...state,
                activeNote: action.payload,
            };

        case ActionTypes.RESET_PERSONAL_NOTE:
            return {
                ...state,
                ...action.payload,
            };

        default: return state;
    }
}

export default NotesReducers;
